module.exports = {
  footerText: 'Copyright EON © 2020',
}
